<template>
  <div class="meeting">
    <div class="selectionBar">
      <div @click="areaShow = true" class="selectionBar-area">
        <img src="@/assets/images/location.png" alt="" class="selectionBar-location" />
        <span class="area-font">{{ area }}</span>
        <img src="@/assets/images/more.png" alt="" />
      </div>
      <div class="bookingGoBlock">
        <div class="booking" @click="toBooking">{{ $t('我的会议') }}</div> <img src="@/assets/images/workStationArrow.png"
          alt="" />
      </div>
    </div>
    <div class="calendarWeed">
      <div class="timeLine">
        <div v-for="item in weekdayList" :key="item.today" class="dayBlock" :style="{
          backgroundColor: item.backgroundColor,
          color: item.color,
          fontWeight: item.fontWeight,
        }" @click="choseWeekDay(item)">
          <div>{{ item.today }}</div>
          <div>{{ item.weekday }}</div>
        </div>
      </div>
      <div class="calendar" @click="dateShow = true">
        <img src="@/assets/images/calendar.png" alt="" />
        <img src="@/assets/images/calendar-down.png" alt="" class="calendar-down" />
      </div>
    </div>
    <div class="meetingState-color">
      <div v-for="item in statusList" :key="item.state">
        <span :style="{ backgroundColor: item.color }"></span>{{ item.state }}
      </div>
    </div>
    <div class="content">
      <div class="card content-box" @click="openOnlineMeetingList">
        <div class="online-card">
          <img src="@/assets/images/online-meeting.png" alt="" />
          <span>{{ $t('我的线上会议') }}</span>
        </div>
        <ul class="meeting-status"></ul>
        <ul class="meeting-timeRange">
          <li v-for="(item, idx) in onlineMeetingTimeRange" :key="item + 1007">
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
      <div class="meetingRoomType"><span></span>{{ $t('常用会议室') }}</div>
      <div class="loading-style" v-if="isLoading">
        <van-loading type="spinner" vertical>{{ $t('加载中...') }}</van-loading>
      </div>
      <ul v-if="uesdMeetingRoomList.length > 0 && !isLoading">
        <li class="card" v-for="item in uesdMeetingRoomList" :key="item.id" @click="meetingStatus(item)">
          <div class="meetingRoom">
            <div>
              <div class="meetingRoom-name">{{ item.name }}</div>
              <div class="meetingRoom-detail">
                <div class="meetingRoom-font meetingRoom-margin">
                  <img src="@/assets/images/user_meeting.png" alt="" class="meetingRoom-peple" />
                  <span>{{ item.peopleNumber }}{{ $t('人') }}</span>
                </div>
                <div class="meetingRoom-font" v-if="item.deviceList" :style="{ display: 'flex' }">
                  <img src="@/assets/images/config.png" alt="" class="meetingRoom-peple" />
                  <div class="config-Box">
                    <span>{{ item.deviceList }}</span>
                  </div>
                </div>
              </div>
            </div>
            <img :src="item.photo" :alt="$t('会议室照片')" class="meetingRoom-photo" v-show="item.photo" />
          </div>
          <ul class="meeting-status">
            <li v-for="(itemChild, idx) in item.meetingStatus" :key="item.id + idx"
              :style="{ background: itemChild.status }"></li>
          </ul>
          <ul class="meeting-timeRange">
            <li v-for="(item, idx) in timeRange" :key="item + 8777">
              <span>{{ item }}</span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="card no-uesdMeetingRoom" v-if="uesdMeetingRoomList.length == 0 && !isLoading">
        <img src="@/assets/images/empty.png" alt="" />
        <div>{{ $t('暂无常用会议室哦～') }}</div>
      </div>
      <div v-if="meetingRoom.length > 0" class="meeting-bottom">
        <div class="meetingRoomType"><span></span>{{ $t('其他会议室') }}</div>
        <div class="loading-style" v-if="isLoading">
          <van-loading type="spinner" vertical>{{
            $t('加载中...')
          }}</van-loading>
        </div>
        <ul v-if="!isLoading">
          <li class="card" v-for="item in meetingRoom" :key="item.id" @click="meetingStatus(item)">
            <div class="meetingRoom">
              <div>
                <div class="meetingRoom-name">{{ item.name }}</div>
                <div class="meetingRoom-detail">
                  <div class="meetingRoom-font meetingRoom-margin">
                    <img src="@/assets/images/user_meeting.png" alt="" class="meetingRoom-peple" />
                    <span>{{ item.peopleNumber }}{{ $t('人') }}</span>
                  </div>
                  <div class="meetingRoom-font" v-if="item.deviceList" :style="{ display: 'flex' }">
                    <img src="@/assets/images/config.png" alt="" class="meetingRoom-peple" />
                    <div class="config-Box">
                      <span>{{ item.deviceList }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <img :src="item.photo" :alt="$t('会议室照片')" class="meetingRoom-photo" v-show="item.photo" />
            </div>
            <ul class="meeting-status">
              <li v-for="(itemChild, idx) in item.meetingStatus" :key="item.id + idx"
                :style="{ background: itemChild.status }"></li>
            </ul>
            <ul class="meeting-timeRange">
              <li v-for="(item, idx) in timeRange" :key="item + 5777">
                <span>{{ item }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-else class="meeting-bottom"></div>
    </div>

    <TabBar v-if="sourceIsH5" />
    <van-calendar v-model="dateShow" @confirm="onConfirm" :title="$t('日期筛选')" color="#009BFF" :formatter="formatter"
      :default-date="date" :date="date" />
    <van-action-sheet v-model="areaShow" :actions="areaList" :title="$t('选择地区')" @select="onAreaConfirm" />
    <van-popup v-model="showStatus" position="bottom" closeable safe-area-inset-bottom>
      <div>
        <div class="meetingRoomDetail">
          <div class="meetingRoomDetail-name">{{ meetingRoomDetail.name }}</div>
          <div class="meetingRoomDetail-font">
            <span>{{ meetingRoomDetail.deviceList }}</span>
          </div>
          <div class="meetingRoomDetail-font meetingRoomDetail-box">
            <img src="@/assets/images/user_meeting.png" alt="" class="meetingRoom-peple" />
            <span>{{ meetingRoomDetail.peopleNumber }}{{ $t('人') }}</span>
          </div>
        </div>
        <van-checkbox-group v-model="result" class="timeList">
          <div class="timeList-box">
            <van-checkbox :name="idx" class="timeListCard" icon-size="21px" :disabled="ifFree(item.status, item.endTime) ||
              (isReviewed && item.current)
              " v-for="(item, idx) in validMeetingTimeRange" :key="idx + 30000" @click="clickTime(idx)">
              <div class="timeListRange">
                <span :style="{ width: '24vw' }">{{ item.startTime }}~{{ item.endTime }}</span>
                <span class="extra">
                  <span v-if="item.extra">{{ item.extra }}</span>
                  <span v-else-if="item.conflict" style="color: #999">{{
                    $t('该时间已参加其他会议')
                  }}</span>
                  <span v-else-if="item.current" style="color: #009bff">{{
                    $t('当前时段')
                  }}</span>
                </span>
              </div>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>
      <div class="bookBox">
        <van-button round block type="info" native-type="submit" class="book-btn" @click="toMeetingInform">{{ isReviewed
          ? $t('立即申请') : $t('立即预约') }}</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showOnlineStatus" position="bottom" closeable safe-area-inset-bottom>
      <div>
        <div class="onlineDetail">
          <div class="meetingRoomDetail-name">{{ $t('发起线上会议') }}</div>
        </div>
        <van-checkbox-group v-model="onlineResult" class="timeList">
          <div class="timeList-box">
            <van-checkbox :name="idx" class="timeListCard" icon-size="21px"
              v-for="(item, idx) in validOnlineMeetingTimeRange" :key="idx + 30000" @click="clickOnlineTime(idx)">
              <div class="timeListRange">
                <span :style="{ width: '24vw' }">{{ item.startTime }}~{{ item.endTime }}</span>
                <span class="extra">
                  <span v-if="item.conflict" style="color: #999">{{
                    $t('该时间已参加其他会议')
                  }}</span>
                  <span v-else-if="item.current" style="color: #009bff">{{
                    $t('当前时段')
                  }}</span>
                </span>
              </div>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>
      <div class="bookBox">
        <van-button round block type="info" native-type="submit" class="book-btn" @click="toOnlineMeetingInform">{{
          $t('立即预约') }}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import i18n from 'i18n'

import dayjs from 'dayjs'
import {
  queryAppointmentList,
  getMeetingRoomConfig,
  getMeetingRoomByArea,
  getMeetingDevice,
  getHoliday,
  getUserList,
  getHoldUpTime,
  meetingRoomMostUsed,
  getIncludeWorkspace,
  dateOverlap,
  queryMeetingDevice,
  querySuperiorWorkspace,
  whetherNeedApproval,
} from '@/services/api'
import TabBar from '@/components/tabBar'
import { getWebSocketOrigin } from '@/utils/utils'
import Vue from 'vue'

import {
  Calendar,
  Popup,
  Checkbox,
  CheckboxGroup,
  Button,
  Toast,
  ActionSheet,
  Empty,
  Tab,
  Tabs,
  Loading,
} from 'vant'
Vue.use(Calendar)
Vue.use(Popup)
Vue.use(Empty)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Button)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Loading)

const statusColorMap = {
  normal: '#F1F6FC',
  iReservation: '#4491FF',
  participated: '#1AC0FF',
  oReservation: '#0CD342',
  occupying: '#FFC70A',
  ended: '#D9D9D9',
}
const statusTextMap = {
  normal: '正常',
  iReservation: '我预订',
  participated: '我参与',
  oReservation: '他人预订',
  occupying: '占用中',
  ended: '已结束',
}
export default {
  name: 'Meeting',
  components: {
    TabBar,
  },
  data() {
    return {
      wholeMeetingRoomList: [],
      user: {},
      value: 0,
      date: new Date(),
      weekdayList: [],
      areaShow: false,
      area: this.$t('全部'),
      areaList: [{ name: this.$t('全部') }],
      areaId: '',
      areaIdList: [],
      dateShow: false,
      meetingRoom: [],
      deviceList: [],
      showStatus: false,
      showOnlineStatus: false,
      meetingRoomDetail: [],
      result: [],
      onlineResult: [],
      meetingRoomConfig: {},
      sourceIsH5: true,
      staffUseList: [],
      webSocket: null,
      occupiedMeetingRoomList: {},
      allUesdMeetingRoom: [],
      uesdMeetingRoomList: [],
      meetingPadConfig: {},
      isLoading: false,
      meetingStatusList: [],
      onlineMeetingStatusList: [],
      selfSchedule: [],
      isReviewed: false,
      isChoseDep: false,
      processConfigId: '',
    }
  },
  computed: {
    statusList() {
      return Object.keys(statusColorMap)
        .filter((state) => state != 'normal')
        .map((state) => ({
          state: i18n.t(statusTextMap[state]),
          color: statusColorMap[state],
        }))
    },
    dateStr() {
      return dayjs(this.date).format('YYYY-MM-DD')
    },
    timeUnit() {
      return this.meetingRoomConfig?.timeUnit
    },
    timeRange() {
      const { scheduledStartTime, scheduledEndTime } = this.meetingRoomConfig

      return Array(
        this.hour2num(scheduledEndTime) - this.hour2num(scheduledStartTime)
      )
        .fill(Object.create(null))
        .map((_, i) => i + this.hour2num(scheduledStartTime))
    },
    onlineMeetingTimeRange() {
      return Array(24)
        .fill(Object.create(null))
        .map((_, i) => i)
    },
    validMeetingTimeRange() {
      return this.meetingRoomDetail?.meetingStatus
        ?.filter((v) => dayjs(this.dateStr + v.endTime).isAfter(dayjs()))
        .map((v) => ({
          ...v,
          conflict: this.selfSchedule?.some((s) =>
            dayjs(this.dateStr + v.endTime).isBetween(
              dayjs(s.beginTime),
              dayjs(s.endTime),
              'minutes',
              '(]'
            )
          ),
          current: dayjs().isBetween(
            dayjs(this.dateStr + v.startTime),
            dayjs(this.dateStr + v.endTime),
            'minutes',
            '[]'
          ),
        }))
    },
    validOnlineMeetingTimeRange() {
      return this.onlineMeetingStatusList
        ?.filter((v) => dayjs(this.dateStr + v.endTime).isAfter(dayjs()))
        .map((v) => ({
          ...v,
          conflict: this.selfSchedule?.some((s) =>
            dayjs(this.dateStr + v.endTime).isBetween(
              dayjs(s.beginTime),
              dayjs(s.endTime),
              'minutes',
              '(]'
            )
          ),
          current: dayjs().isBetween(
            dayjs(this.dateStr + v.startTime),
            dayjs(this.dateStr + v.endTime),
            'minutes',
            '[]'
          ),
        }))
    },
  },
  methods: {
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    toBooking() {
      this.$router.push('bookMeetings')
    },
    toOnlineMeetingInform() {
      if (this.onlineResult.length < 1) {
        Toast.fail(this.$t('请选择时间段'))
        return
      }
      this.onlineResult.sort(function (a, b) {
        return a - b
      })
      let continuous = this.onlineResult.every((val, idx) => {
        if (idx == this.onlineResult.length - 1) {
          return true
        } else {
          return this.onlineResult[idx + 1] - val == 1
        }
      })
      if (continuous) {
        let startTime =
          this.validOnlineMeetingTimeRange[this.onlineResult[0]].startTime
        let endTime =
          this.validOnlineMeetingTimeRange[
            this.onlineResult[this.onlineResult.length - 1]
          ].endTime
        if (
          dayjs(this.dateStr + ' ' + endTime).valueOf() -
          dayjs(this.dateStr + ' ' + startTime).valueOf() >
          this.meetingRoomConfig.scheduledMaxTime * 60 * 60 * 1000
        ) {
          let maxTime = 0
          if (this.meetingRoomConfig.scheduledMaxTime >= 1) {
            maxTime =
              this.meetingRoomConfig.scheduledMaxTime + ' ' + this.$t('小时')
          } else {
            maxTime =
              this.meetingRoomConfig.scheduledMaxTime * 60 +
              ' ' +
              this.$t('分钟')
          }
          Toast.fail(
            this.$t('超过最大预约时间段:{maxTime}', { maxTime: maxTime })
          )
          return
        }

        const params = {
          startTime,
          endTime,
          date: dayjs(this.date).format(this.$t('M月D日 ddd')),
          length: this.onlineResult.length,
          parameterDate: this.dateStr,
          nowDate: this.date,
          result: this.onlineResult,
          timeUnit: this.timeUnit,
          scheduledDateLimit: this.meetingRoomConfig.scheduledDateLimit,
          scheduledMaxTime: this.meetingRoomConfig.scheduledMaxTime,
          ifOnline: true,
        }
        localStorage.setItem(
          'meetingInformParams',
          JSON.stringify(params)
        )
        // undo push 到创建页
        this.$router.push({
          name: 'Inform',
          params: params,
        })
      } else {
        Toast.fail(this.$t('预约时间段之间需连续'))
      }
    },
    toMeetingInform() {
      if (this.result.length < 1) {
        Toast.fail(this.$t('请选择时间段'))
        return
      }
      this.result.sort(function (a, b) {
        return a - b
      })

      let continuous = this.result.every((val, idx) => {
        if (idx == this.result.length - 1) {
          return true
        } else {
          return this.result[idx + 1] - val == 1
        }
      })
      if (continuous) {
        let startTime = this.validMeetingTimeRange[this.result[0]].startTime
        let endTime =
          this.validMeetingTimeRange[this.result[this.result.length - 1]]
            .endTime
        if (
          dayjs(this.dateStr + ' ' + endTime).valueOf() -
          dayjs(this.dateStr + ' ' + startTime).valueOf() >
          this.meetingRoomConfig.scheduledMaxTime * 60 * 60 * 1000
        ) {
          let maxTime = 0
          if (this.meetingRoomConfig.scheduledMaxTime >= 1) {
            maxTime =
              this.meetingRoomConfig.scheduledMaxTime + ' ' + this.$t('小时')
          } else {
            maxTime =
              this.meetingRoomConfig.scheduledMaxTime * 60 +
              ' ' +
              this.$t('分钟')
          }
          Toast.fail(
            this.$t('超过最大预约时间段:{maxTime}', { maxTime: maxTime })
          )
          return
        }
        // undo push 到创建页
        const params = {
          startTime,
          endTime,
          date: dayjs(this.date).format(this.$t('M月D日 ddd')),
          meetingRoomName: this.meetingRoomDetail.name,
          meetingRoomId: this.meetingRoomDetail.id,
          length: this.result.length,
          parameterDate: this.dateStr,
          nowDate: this.date,
          result: this.result,
          timeUnit: this.timeUnit,
          scheduledDateLimit: this.meetingRoomConfig.scheduledDateLimit,
          scheduledMaxTime: this.meetingRoomConfig.scheduledMaxTime,
          isReviewed: this.isReviewed,
          isChoseDep: this.isChoseDep,
          processConfigId: this.processConfigId,
        }
        localStorage.setItem(
          'meetingInformParams',
          JSON.stringify(params)
        )
        this.$router.push({
          name: 'Inform',
          params: params,
        })
      } else {
        Toast.fail(this.$t('预约时间段之间需连续'))
      }
    },
    // 日期选择
    async onConfirm(date) {
      console.log(this.meetingPadConfig)

      this.date = date
      this.getWeekdayTime(date)
      await this.getMeetingRoomInformation()
      if (this.meetingRoomConfig.scheduledDateLimit != 'everyday') {
        const ifHoliday = await getHoliday(dayjs(date).format('YYYYMMDD'))
        if (ifHoliday != 0) {
          Toast.fail(this.$t('节假日不能预约会议室'))
          this.meetingRoom = []
          return
        }
      }
      this.dateShow = false
    },
    getWeekdayTime(date) {
      let allDay = []
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')
      for (let i = 0; i < 7; i++) {
        let day = dayjs(date).add(i, 'day')
        let time = `${new Date(day).getMonth() + 1}-${new Date(day).getDate()}`
        let week = weekday[new Date(day).getDay()]
        if (i == 0) {
          if (dayjs().isSame(dayjs(day), 'day')) {
            allDay.push({
              day: day,
              today: this.$t('今天'),
              weekday: week,
              color: '#4491FF',
              backgroundColor: '#E0EEFF',
              fontWeight: 500,
            })
          } else {
            allDay.push({
              day: day,
              today: time,
              weekday: week,
              color: '#4491FF',
              backgroundColor: '#E0EEFF',
              fontWeight: 500,
            })
          }
        } else {
          allDay.push({
            day: day,
            today: time,
            weekday: week,
            color: '',
            backgroundColor: '',
            fontWeight: 400,
          })
        }
      }
      this.weekdayList = allDay
    },
    onAreaConfirm(v, idx) {
      this.area = v.name
      this.areaShow = false
      this.areaId = this.areaIdList[idx - 1]
      // undo
      this.getMeetingRoomInformation()
    },
    onAreaCancel() {
      this.areaShow = false
    },
    hour2num(str) {
      return parseInt(str?.slice(0, 2) ?? 0)
    },
    // 选择周日历
    async choseWeekDay(data) {
      this.weekdayList.map((item) => {
        if (item.weekday == data.weekday) {
          item.color = statusColorMap['iReservation']
          item.backgroundColor = '#E0EEFF'
        } else {
          item.color = ''
          item.backgroundColor = ''
        }
      })
      let date = new Date(data.day)
      this.date = date
      await this.getMeetingRoomInformation()
      if (this.meetingRoomConfig.scheduledDateLimit != 'everyday') {
        const ifHoliday = await getHoliday(dayjs(date).format('YYYYMMDD'))
        if (ifHoliday != 0) {
          Toast.fail(this.$t('节假日不能预约会议室'))
          this.meetingRoom = []
          return
        }
      }
    },
    // 获取会议时间
    async getMeetingTimeRange(developerId) {
      try {
        const res = await getMeetingRoomConfig({
          developerId,
        })

        this.meetingRoomConfig = res
        if (this.meetingRoomConfig.scheduledEndTime == '23:59') {
          this.meetingRoomConfig.scheduledEndTime = '24:00'
        }

        const { scheduledStartTime, scheduledEndTime, timeUnit } =
          this.meetingRoomConfig

        this.meetingStatusList = Array(
          dayjs(scheduledEndTime, 'HH:mm').diff(
            dayjs(scheduledStartTime, 'HH:mm'),
            'minute'
          ) / timeUnit
        )
          .fill(Object.create(null))
          .map((_, i) => ({
            startTime: dayjs(scheduledStartTime, 'HH:mm')
              .add(i * timeUnit, 'minute')
              .format('HH:mm'),
            endTime: dayjs(scheduledStartTime, 'HH:mm')
              .add((i + 1) * timeUnit, 'minute')
              .format('HH:mm'),
            status: '#F1F6FC',
          }))

        this.onlineMeetingStatusList = Array(
          dayjs('24:00', 'HH:mm').diff(dayjs('00:00', 'HH:mm'), 'minute') /
          timeUnit
        )
          .fill(Object.create(null))
          .map((_, i) => ({
            startTime: dayjs('00:00', 'HH:mm')
              .add(i * timeUnit, 'minute')
              .format('HH:mm'),
            endTime: dayjs('00:00', 'HH:mm')
              .add((i + 1) * timeUnit, 'minute')
              .format('HH:mm'),
            status: '#F1F6FC',
          }))
      } catch (error) {
        console.log(error)
      }
    },
    //获取会议室信息
    async getMeetingRoomInformation() {
      const developerId = this.user.companyId

      const workspaceId = this.areaId
      this.isLoading = true
      try {
        const meetingDeviceList = await getMeetingDevice({
          developerId,
        }).catch((err) => {
          console.log(err.response.data.message)
        })

        this.wholeMeetingRoomList = (
          await getMeetingRoomByArea({
            developerId,
            workspaceId: workspaceId ? workspaceId : undefined,
          })
        ).map((item, idx) => ({
          ...item,
          sort: item?.sort ?? idx + 1,
          photo: item?.photo ?? `${require('@/assets/images/meetingRoom.png')}`,
          deviceList: item.deviceId
            ?.split(',')
            .map((id) => meetingDeviceList.find((v) => v.id == id)?.name)
            ?.join('/'),
        }))

        const tmpArr = [...this.wholeMeetingRoomList]

        // 如果开了人体感应器配置，则启用“占用中”状态
        if (this.meetingPadConfig?.holdButtonFlag) {
          getHoldUpTime(this.wholeMeetingRoomList.map((item) => item.id)).then(
            (res) => {
              for (let key in res) {
                res[key] = JSON.parse(res[key])
              }
              console.log(res)

              this.occupiedMeetingRoomList = res
            }
          )
        }

        await Promise.all(
          tmpArr.map((item) =>
            this.getAppointmentList(developerId, this.dateStr, item.id).then(
              (resolve) => {
                let resolveLong = [...resolve]
                if (
                  resolve.length > 0 &&
                  resolve[resolve.length - 1].startTime.split(':')[0] == 23
                ) {
                  resolveLong.push({
                    endTime: '24:00',
                    startTime: '23:--',
                    status: '#F1F6FC',
                  })
                }
                item.meetingStatus = resolve
                item.meetingStatusLong = resolveLong
              }
            )
          )
        )
        let usedIdList = this.allUesdMeetingRoom
        let usedList = []
        let otherList = []
        tmpArr.forEach((item) => {
          if (usedIdList.includes(item.id) && item.state != 'nouse') {
            item.sortNum = usedIdList.indexOf(item.id)
            usedList.push(item)
          } else if (item.state != 'nouse') {
            otherList.push(item)
          }
        })
        usedList.sort((a, b) => {
          return a.sortNum - b.sortNum
        })
        if (usedList.length > 5) {
          let arr1 = usedList.slice(5, usedList.length)
          usedList = usedList.slice(0, 5)
          otherList = [...arr1, ...otherList]
        }
        otherList.sort((a, b) => {
          return a.sort - b.sort
        })
        this.uesdMeetingRoomList = [...usedList]
        this.meetingRoom = [...otherList]
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async getAreaId(developerId) {
      try {
        const res = await querySuperiorWorkspace({
          developerId,
          selectionType: 'MEETING_ROOM',
        })
        res.forEach((v) => {
          this.areaIdList.push(v.id)
          this.areaList.push({ name: v.name })
        })
      } catch (error) {
        console.log(error.response.data.message)
      }
    },

    getEarlyTime(data, min) {
      let earlyTime = ''
      if (!data.actualStartTime) {
        earlyTime = data.appointmentStartTime
      } else {
        if (
          dayjs(data.actualStartTime).isBefore(dayjs(data.appointmentStartTime))
        ) {
          let minute = parseInt(
            dayjs(data.actualStartTime).format('HH:mm').split(':')[1]
          )
          let remainder = minute % min
          earlyTime = dayjs(data.actualStartTime)
            .subtract(remainder, 'minute')
            .format('YYYY-MM-DD HH:mm:00')
        } else {
          earlyTime = data.appointmentStartTime
        }
      }
      return earlyTime
    },

    getdelayTime(data, min) {
      let delayTime = ''
      if (!data.actualEndTime) {
        delayTime = data.appointmentEndTime
      } else {
        if (
          dayjs(data.actualEndTime).isBefore(dayjs(data.appointmentEndTime))
        ) {
          let minute = parseInt(
            dayjs(data.actualEndTime).format('HH:mm').split(':')[1]
          )
          let remainder = minute % min != 0 ? min - (minute % min) : 0
          delayTime = dayjs(data.actualEndTime)
            .add(remainder, 'minute')
            .format('YYYY-MM-DD HH:mm:00')
        } else {
          delayTime = data.appointmentEndTime
        }
      }
      return delayTime
    },
    // 获取会议预约表
    async getAppointmentList(companyId, date, meetingRoomId) {
      try {
        const res = await queryAppointmentList({
          date,
          meetingRoomId,
          companyId,
          meetingBoard: 1,
        })

        let ifAdvanced = false
        return this.meetingStatusList.map((i) => {
          const item = { ...i }
          let startTime = dayjs(date + ' ' + item.startTime).valueOf()
          let endTime =
            item.endTime === '00:00'
              ? dayjs(date + ' ' + item.endTime)
                .add(1, 'day')
                .valueOf()
              : dayjs(date + ' ' + item.endTime).valueOf()
          if (res.length > 0) {
            res.forEach((v) => {
              if (v.state == 'cancel' && v.autoRelease != 1) return
              if (v.appointmentStaff == -1) {
                if (
                  (startTime >=
                    dayjs(this.getEarlyTime(v, this.timeUnit)).valueOf() &&
                    startTime <=
                    dayjs(this.getdelayTime(v, this.timeUnit)).valueOf()) ||
                  (endTime >=
                    dayjs(this.getEarlyTime(v, this.timeUnit)).valueOf() &&
                    endTime <=
                    dayjs(this.getdelayTime(v, this.timeUnit)).valueOf()) ||
                  (dayjs(this.getEarlyTime(v, this.timeUnit)).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    endTime !=
                    dayjs(this.getEarlyTime(v, this.timeUnit)).valueOf()) ||
                  (dayjs(this.getdelayTime(v, this.timeUnit)).isBetween(
                    dayjs(startTime),
                    dayjs(endTime),
                    'minutes',
                    '[]'
                  ) &&
                    startTime !=
                    dayjs(this.getdelayTime(v, this.timeUnit)).valueOf())
                ) {
                  item.status = statusColorMap['oReservation']
                  item.extra = this.$t('已被临时人员预订')
                  if (
                    v.actualEndTime &&
                    dayjs(this.getdelayTime(v, this.timeUnit)).valueOf() <
                    dayjs(endTime).valueOf()
                  ) {
                    item.extra = ``
                    item.status = statusColorMap['normal']
                  }
                  if (endTime <= dayjs().valueOf()) {
                    item.extra = ``
                    item.status = statusColorMap['normal']
                  }
                  return
                }
              }

              if (
                v.actualStartTime &&
                v.appointmentStaff !== -1 &&
                ((dayjs(v.actualStartTime).valueOf() >= startTime &&
                  dayjs(v.actualStartTime).valueOf() <= endTime) ||
                  (dayjs(v.actualStartTime).valueOf() <= endTime &&
                    dayjs(v.appointmentStartTime).valueOf() >= endTime))
              ) {
                ifAdvanced = true
              } else {
                ifAdvanced = false
              }
              let replaceStaff = []
              let replaceStaffId = v && v.replaceAppointmentStaff
              if (replaceStaffId) {
                replaceStaff = this.staffUseList.filter(
                  (staffItem) => staffItem.id == replaceStaffId
                )
              }
              if (
                ifAdvanced ||
                (startTime >=
                  dayjs(this.getEarlyTime(v, this.timeUnit)).valueOf() &&
                  endTime <=
                  dayjs(this.getdelayTime(v, this.timeUnit)).valueOf()) ||
                (dayjs(this.getEarlyTime(v, this.timeUnit)).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  endTime !=
                  dayjs(this.getEarlyTime(v, this.timeUnit)).valueOf()) ||
                (dayjs(this.getdelayTime(v, this.timeUnit)).isBetween(
                  dayjs(startTime),
                  dayjs(endTime),
                  'minutes',
                  '[]'
                ) &&
                  startTime !=
                  dayjs(this.getdelayTime(v, this.timeUnit)).valueOf())
              ) {
                item.extra =
                  v.meetingSource == 'PROCESS'
                    ? v.staffName
                      ? this.$t('已被{slot1}申请', { slot1: v.staffName })
                      : replaceStaff && replaceStaff.length > 0
                        ? '(' + replaceStaff[0].name + this.$t('代申请)')
                        : ''
                    : this.$t('已被{slot1}预订{slot2}', {
                      slot1: v.staffName,
                      slot2:
                        replaceStaff && replaceStaff.length > 0
                          ? '(' + replaceStaff[0].name + this.$t('代预订)')
                          : '',
                    })

                // fix: #6879 偶发显示已被其他人预定但是没有 disabled 的情况，怀疑是下面的判断一个都没生效导致
                // 这里默认是被其他人预定
                item.status = statusColorMap['oReservation']
                if (v.appointmentStaff == this.user.id) {
                  if (v.meetingSource == 'PROCESS') {
                    item.status = statusColorMap['iReservation']
                  } else {
                    item.status = statusColorMap['iReservation']
                  }
                } else {
                  if (
                    v.meetingPeopleId &&
                    v.meetingPeopleId.includes(this.user.id)
                  ) {
                    v?.attendDetails?.forEach((item1) => {
                      if (item1.staffId == this.user.id) {
                        item1.agree == true
                          ? (item.status = statusColorMap['participated'])
                          : v.meetingSource == 'PROCESS'
                            ? (item.status = statusColorMap['oReservation'])
                            : (item.status = statusColorMap['oReservation'])
                      }
                    })
                  } else {
                    if (v.meetingSource == 'PROCESS') {
                      item.status = statusColorMap['oReservation']
                    } else {
                      item.status = statusColorMap['oReservation']
                    }
                  }
                }
                if (
                  v.actualEndTime &&
                  dayjs(this.getdelayTime(v, this.timeUnit)).valueOf() <
                  dayjs(endTime).valueOf()
                ) {
                  item.extra = ``
                  item.status = statusColorMap['normal']
                }
                if (endTime <= dayjs().valueOf())
                  item.status = statusColorMap['ended']
              }
            })
          }
          //如果该时段状态为空闲中，判断该时段是否为当前时间所在的时段，如果是，判断是否是占用中

          if (
            this.meetingPadConfig?.holdButtonFlag &&
            item.status == statusColorMap['normal'] &&
            dayjs().valueOf() > startTime &&
            dayjs().valueOf() < endTime &&
            this.occupiedMeetingRoomList[meetingRoomId] &&
            this.occupiedMeetingRoomList[meetingRoomId].state == true
          ) {
            item.status = statusColorMap['occupying']
            item.extra = this.$t('临时占用')
          }
          return item
        })
      } catch (error) {
        console.log(error)
      }
    },
    async openOnlineMeetingList() {
      this.onlineResult = []
      const selectDate = this.dateStr
      this.selfSchedule = (
        await dateOverlap({
          staffIds: this.user.id,
          beginTime: selectDate + ' 00:00:00',
          endTime: selectDate + ' 24:00:00',
        })
      )?.[0]?.dateOverlaps

      this.showOnlineStatus = true
    },
    async meetingStatus(item) {
      this.result = []
      let selectDate = this.dateStr
      this.selfSchedule = (
        await dateOverlap({
          staffIds: this.user.id,
          beginTime: selectDate + ' 00:00:00',
          endTime: selectDate + ' 24:00:00',
        })
      )?.[0]?.dateOverlaps
      this.meetingRoomDetail = item
      this.showStatus = true
    },
    ifFree(color, date) {
      date = this.dateStr + ' ' + date
      if (dayjs().valueOf() >= dayjs(date).valueOf()) {
        return true
      } else {
        if (color == statusColorMap['normal']) {
          return false
        } else {
          return true
        }
      }
    },
    async getUserList() {
      const user = JSON.parse(localStorage.getItem('user'))
      const res = await getUserList({ companyId: user.companyId })
      this.staffUseList = res
    },
    /**
     * 获取会议室配置，如果开了人体感应器配置，则启用“占用中”状态
     */
    async getMeetingDevice(companyId) {
      const res = await queryMeetingDevice(companyId)
      this.meetingPadConfig = res
      if (res && res.holdButtonFlag && res.sensorSign) {
        this.connectWebSocket()
      }
    },
    connectWebSocket() {
      let url = `${getWebSocketOrigin()}/newworkwss/ws/${this.user.id}`
      this.webSocket = new WebSocket(url)

      this.webSocket.onopen = () => {
        console.log('websocket连接成功')
      }
      this.webSocket.onclose = () => {
        this.webSocket.close()
        console.log('websocket连接已关闭')
      }
      this.webSocket.onmessage = (res) => {
        console.log('会议室状态变化')
        if (res.data.indexOf(this.$t('成功')) != -1) return
        try {
          const message = JSON.parse(res.data)
          if (message?.msgType == 'holdUpTime') {
            this.onConfirm(this.date)
          }
        } catch (ignore) { }
      }
      this.webSocket.onerror = (res) => {
        console.log('websocket连接失败')
        // 打印失败的数据
        console.log(res)
      }
    },
    async getUsed(staffId, developerId) {
      let res = await meetingRoomMostUsed({ staffId, developerId })
      let roomlist = Array.isArray(res) ? res.map((item) => item.id) : []
      this.allUesdMeetingRoom = roomlist
      this.getAreaId(this.user.companyId)
    },
    async getALLRule(staffId, developerId) {
      await whetherNeedApproval({
        staffId: staffId,
        processType: 'MEETING_ROOM_RESERVATION_APPROVAL',
        companyId: developerId,
      }).then((res) => {
        if (res && res.length && res[0]) {
          this.isReviewed = true
          let rule = res[0]
          this.processConfigId = rule.id
          if (rule?.approverDeptManager) {
            this.isChoseDep = true
          }
        } else {
          this.isReviewed = false
          this.isChoseDep = false
          this.processConfigId = ''
        }
      })
    },
    clickTime(index) {
      if (this.result.length < 2) return
      if (!this.result.some((num) => num == index)) return
      let arr = [...this.result]
      arr.sort((a, b) => a - b)
      let addList = []
      let ifOccupied = false
      for (let i = arr[0]; i <= arr[arr.length - 1]; i++) {
        if (
          this.validMeetingTimeRange[i].status !==
          statusColorMap['normal']
        ) {
          this.result = arr.filter((num) => num != index)
          ifOccupied = true
          Toast.fail(this.$t('预约时间段之间存在已被占用的时间段'))
          break
        }
        addList.push(i)
      }
      if (!ifOccupied) {
        this.result = addList
      }
    },
    clickOnlineTime(index) {
      if (this.onlineResult.length < 2) return
      if (!this.onlineResult.some((num) => num == index)) return
      let arr = [...this.onlineResult]
      arr.sort((a, b) => a - b)
      let addList = []
      for (let i = arr[0]; i <= arr[arr.length - 1]; i++) {
        addList.push(i)
      }
      this.onlineResult = addList
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    await this.getMeetingDevice(this.user.companyId)
    this.getUsed(this.user.id, this.user.companyId)
    this.getMeetingTimeRange(this.user.companyId)
    this.onConfirm(new Date())
    this.getWeekdayTime(new Date())
    this.getUserList()
    this.getALLRule(this.user.id, this.user.companyId)
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
  beforeDestroy() {
    this.webSocket && this.webSocket.close()
  },
}
</script>
<style lang="less" scoped>
.meeting {
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    margin-bottom: 84px;
    overflow: auto;
  }
}

// .navBar {
//   background: #ffffff;
//   line-height: 40px;
//   text-align: center;
//   font-size: 18px;
//   height: 40px;
//   .booking {
//     padding-right: 12px;
//     font-size: 14px;
//     position: absolute;
//     top: 0;
//     right: 0px;
//   }
//   .title {
//     font-size: 17px;
//     font-weight: 500;
//   }
// }
.selectionBar {
  height: 40px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;

  >div {
    display: flex;
    // width: 50%;
    align-items: center;

    span {
      padding: 0px 4px;
    }
  }

  .selectionBar-area {
    justify-content: flex-start;
    padding-right: 12px;
    width: 180px;

    .area-font {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .selectionBar-location {
      height: 20px;
      width: 20px;
    }
  }

  img {
    height: 16px;
  }

  .meetingArea {
    height: 40px;
    appearance: none;
    font-size: 14px;
    background: #ffffff;
  }
}

.meetingState-color {
  background: #ffffff;
  display: flex;
  // justify-content: space-around;
  padding-left: 16px;
  color: #999999;
  font-size: 12px;
  align-items: center;
  height: 40px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-bottom: 1px #f6f6f6 solid;

  >div {
    display: flex;
    margin-right: 16px;
    align-items: center;

    span {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 8px;
      margin-right: 4px;
    }
  }
}

.no-uesdMeetingRoom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;

  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}

.card {
  height: 136px;
  background: #ffffff;
  margin-top: 12px;
  margin-left: 16px;
  margin-right: 16px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 0 8px;

  .meetingRoom {
    display: flex;
    padding-top: 20px;
    justify-content: space-between;
    margin-bottom: 16px;

    .meetingRoom-photo {
      width: 92px;
      height: 56px;
      border-radius: 2px;
    }

    .meetingRoom-name {
      margin-top: 8px;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .meeting-status {
    height: 10px;
    margin: 0 auto;
    display: flex;

    li {
      height: 100%;
      flex: 1;
    }

    .meeting-blank {
      height: 100%;
      width: 2px;
    }
  }

  .meeting-timeRange {
    display: flex;
    margin-top: 3px;

    li {
      flex: 1;
      color: #c4c4c4;
      line-height: 16px;
      text-align: left;

      span {
        font-size: 10px;
        display: inline-block;
        transform: scale(0.75) translateX(-25%);
      }
    }
  }
}

.meetingRoom-detail {
  width: 210px;
  display: flex;
}

.meetingRoom-font {
  margin-top: 11px;
  font-size: 12px;
  color: #999999;
  line-height: 14px;
  display: flex;
  align-items: center;
  max-width: 150px;

  img {
    height: 14px;
  }

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meetingRoom-peple {
  padding-right: 4px;
}

.onlineDetail {
  padding: 18px 16px;

  .meetingRoomDetail-name {
    font-size: 17px;
    line-height: 24px;
  }
}

.meetingRoomDetail {
  padding: 18px 16px 12px;

  .meetingRoomDetail-name {
    font-size: 17px;
    line-height: 24px;
  }

  .meetingRoomDetail-box {
    line-height: 24px;
    display: flex;
    align-items: center;
  }

  .meetingRoomDetail-font {
    margin-top: 1px;
    font-size: 14px;
    color: #666666;
    line-height: 24px;

    img {
      height: 16px;
    }
  }
}

/deep/.timeList {
  position: relative;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  height: 318px;
  padding-left: 16px;
  overflow: auto;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 329px;
  }

  .timeList-box {
    height: 318px;
  }

  .timeListRange {
    display: block;
    border-top: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    font-size: 16px;
    background: #009bff;
  }
}

/deep/.date-border {
  color: #009bff;
}

.meetingRoomType {
  height: 16px;
  font-size: 13px;
  color: #999999;
  line-height: 16px;
  margin-top: 12px;
  margin-left: 26px;
  display: flex;
  align-items: center;

  >span {
    width: 4px;
    height: 4px;
    background: #3370ff;
    margin-right: 6px;
  }
}

/deep/.custom-image {
  padding: 0;
  height: 160px;

  .van-empty__image {
    width: 140px;
    height: 140px;
  }
}

.calendarWeed {
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  background: #ffffff;
}

.timeLine {
  display: flex;
  align-items: center;
  width: 89%;
  height: 64px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  padding: 0 0 0 4px;
}

.dayBlock {
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
  height: 56px;
  padding: 8px 0px;
  border-radius: 4px;
  margin-right: 8.5px;

  div {
    width: 56px;
    height: 56px;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
  }
}

.calendar {
  height: 64px;
  box-shadow: -15px -2px 5px -13px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    height: 24px;
    width: 24px;
  }

  .calendar-down {
    height: 8px;
    width: 8px;
  }
}

.online-card {
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  padding-top: 16px;
  margin-bottom: 10px;

  img {
    height: 32px;
    width: 32px;
    margin-right: 6px;
  }
}

.config-Box {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-box {
  height: 100px;
  margin-top: 16px;
}

.meetingRoom-margin {
  margin-right: 11px;
}

.meeting-bottom {
  margin-bottom: 11px;
}

.loading-style {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.bookingGoBlock {
  display: flex;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.booking {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #1E2329;
  margin-right: 4px;
}
</style>
